import { render, staticRenderFns } from "./JDPowerBanner.vue?vue&type=template&id=7071b936"
import script from "./JDPowerBanner.vue?vue&type=script&lang=js"
export * from "./JDPowerBanner.vue?vue&type=script&lang=js"
import style0 from "./JDPowerBanner.vue?vue&type=style&index=0&id=7071b936&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports